import React, { Component } from 'react';

import './App.css';

class Todos extends Component {
  render(){
    return this.props.todos.map((todo,index) => 
    <Todo key={todo} count={index + 1} todo={todo}
         removeOneTodo={this.props.removeOneTodo}
     />);
  }
}

class Todo extends Component {
  render(){
    return (
      <div className="todos">
        <p className="todoText">{this.props.count} . {this.props.todo}</p>
        <button className="removeBtn" onClick={() => this.props.removeOneTodo(this.props.todo)}>Remove </button>
      </div>
    );
  }
}

class AddTodo extends React.Component{
  render(){
    return (
      <div >
          <form className="addTodo" onSubmit={this.props.addtodo}>
             <input type="text" name="todoText" />
             <button className="addTodoBtn">Add Todo</button>
          </form>
      </div>
    );
  }
}

class TodoApp extends Component {
  constructor(props){
    super(props);
    this.state ={
       todos: ['Coding','Black Cofee','Coaching','Read book']
    };
    this.removeOneTodo= this.removeOneTodo.bind(this);
    this.addtodo = this.addtodo.bind(this);
    this.removeAllTodo = this.removeAllTodo.bind(this);
  }

  addtodo(event){
    event.preventDefault();
    const inputValue = event.target.elements.todoText.value;
    event.target.elements.todoText.value='';
    //console.log(event.target.elements.todoText.value);
    if(inputValue){
      this.setState((prevState) => {
         return {
            todos: prevState.todos.concat(inputValue)
         };
      });
    }

  }

  removeAllTodo(){
    this.setState({
      todos: []
    });
  }

  removeOneTodo(todoRemove){
   // console.log(todoRemove);
    this.setState((prevState) => {
      return {
        todos: prevState.todos.filter((todo) => {
               return  todo !== todoRemove;
        })
      }
    });
  }

  componentDidMount(){
  const todosSaved = JSON.parse(localStorage.getItem("todos"));
  if(todosSaved){
    this.setState({
      todos: todosSaved
    });
  }
  }

  componentDidUpdate(){
    const arrayStore = JSON.stringify(this.state.todos);
    localStorage.setItem("todos",arrayStore);
  }

  render() {
   
    return (
      <div className="container">
        <h1 className="headerName">Manage yours To Do List </h1>
        <AddTodo addtodo={this.addtodo} />
        
         <button className="resetButton" disabled={this.state.todos.length < 1} onClick={this.removeAllTodo}> Remove all Todos </button> 
         
        <Todos todos={this.state.todos} removeOneTodo={this.removeOneTodo} />
         <footer className="footer">Created By: Avinash</footer>

      </div>
    );
  }
}

export default TodoApp;



// WEBPACK FOOTER //
// ./src/TodoApp.js